import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ChartIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 4V18C4 19.105 4.895 20 6 20H20M8 12V17M15 12V17M11.5 6V17M18.5 6V17"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

ChartIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ChartIcon);
